<template>
    <base-dialog
        :visible="visible"
        title-color="warning"
        persistent
        @close="closeDialog"
    >
        <template v-slot:title>
            <v-layout>
                <v-flex>{{ $t('errors.screening.preferredCommunicationEmail.title') }}</v-flex>
            </v-layout>
        </template>
        <template v-slot:content>
            <v-layout>
                <v-flex pr-4 shrink>
                    <v-icon color="warning">
                        fas fa-exclamation-triangle
                    </v-icon>
                </v-flex>
                <v-flex v-html="$t('errors.screening.preferredCommunicationEmail.message')" />
            </v-layout>
        </template>
    </base-dialog>
</template>

<script>

import BaseDialog from '@/components/dialogs/BaseDialog';

export default {
    name: 'preferred-communication-error',
    components: { BaseDialog },
    props: {
        visible: { type: Boolean, Required: true },
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
    },
};
</script>
